import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ClientSearch from './ClientSearch';

import { fetchSuggestionsClient, clearSuggestionsClient, setClientValue } from 'store/client/clientActions';

class ClientSearchContainer extends React.Component {

    componentWillUnmount() {
        const { clearSuggestionsClient, setClientValue } = this.props;
        clearSuggestionsClient();

        setClientValue('', 0, false);
    }

    handleSearchClients = (searchValue) => {
        const { activitesAutorisees, activitesExclues } = this.props;

        this.props.fetchSuggestionsClient(searchValue, activitesAutorisees, activitesExclues);
    }

    handleClearClients = () => {
        this.props.clearSuggestionsClient();
    }

    handleChange = (value) => {
        const { selectedId } = this.props;
        this.props.setClientValue(value, selectedId, false);
    }

    handleSuggestionSelected = (suggestion) => {

        const { id, code, libelle, chargerContact, chargerContactExclusionMotif } = suggestion;

        const value = id ? code + ' - ' + libelle : '';

        this.props.setClientValue(value, id, chargerContact, chargerContactExclusionMotif);
        this.props.onChange(suggestion);
    }

    render() {
        const { clients, value, selectedId, isRequired, error, autoFocus, client, size } = this.props;

        return (
            <ClientSearch
                clients={clients}
                onSearch={this.handleSearchClients}
                onChange={this.handleChange}
                onClear={this.handleClearClients}
                error={error}
                isRequired={isRequired}
                onSuggestionSelected={this.handleSuggestionSelected}
                value={value}
                selectedId={selectedId}
                autoFocus={autoFocus}
                client={client}
                size={size}
            />);
    }
}


const mapStateToProps = (state, ownProps) => ({
    clients: state.client[ownProps.namespace].suggestions.items,
    value: state.client[ownProps.namespace].suggestions.value,
    selectedId: state.client[ownProps.namespace].suggestions.selectedId
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchSuggestionsClient: (searchValue, activitesAutorisees, activitesExclues) => dispatch(fetchSuggestionsClient(ownProps.namespace, searchValue, activitesAutorisees, activitesExclues)),
    clearSuggestionsClient: () => dispatch(clearSuggestionsClient(ownProps.namespace)),
    setClientValue: (value, selectedId, chargerContact, chargerContactExclusionMotif) => dispatch(setClientValue(ownProps.namespace, value, selectedId, chargerContact, chargerContactExclusionMotif))
});

ClientSearchContainer.propTypes = {
    onChange: PropTypes.func.isRequired,
    isRequired: PropTypes.bool.isRequired,
    error: PropTypes.object,
    activitesAutorisees: PropTypes.array,
    activitesExclues: PropTypes.array,
    size: PropTypes.string,

    autoFocus: PropTypes.bool,
};


ClientSearchContainer.defaultProps = {
    autoFocus: false
}

export default connect(mapStateToProps, mapDispatchToProps)(ClientSearchContainer);